<template>
	<div class="mdc-card mgb-24 mgt-24"  @click="view(degree.id)" @keypress="view(degree.id)" tabindex="0">
		<div class="mdc-card__primary-action pda-24" :id="`listCard${degree.id}`" >
			<div class="d-flex">
				<div class="list-image-list" v-if="degree.thumbnail"  >
					<!-- <img :src="degree.thumbnail ?degree.thumbnail:'https://s3-ap-northeast-1.amazonaws.com/clpintergrateuploadcontents/_kmath/thumnail.jpg'" alt="" class="b-radius4"> -->
					<img :src="degree.thumbnail" :alt="degree.name" class="b-radius4">
				</div>
				<div class="flex-grow-1">
					<div class="t-body6 mgb-4  t-color-bodyGrayA font-r">
						{{degree.category.text}}{{degree.category.child ? ' > ' + degree.category.child.text : ''}}
					</div>
					<div class="t-headline7  mgb-16 font-m t-line-2">
							{{degree.name}}
					</div>
					<div class="t-body6 mgb-2  t-color-bodyGrayA font-r">
						{{degree.lessonCount > 1 ? $t('874',{str: degree.lessonCount}) : $t('874',{str: degree.lessonCount})}}
					</div>
					<div class="t-body6 mgb-2  t-color-bodyGrayA font-r" v-if="degree.levels">
						<span class="font-r t-color-bodyGrayA t-body6 pdr-4" v-for="(level, index) in degree.levels" :key="index" >
							{{level.text}} {{degree.levels.length === index+1 ? '' : '/' }}
						</span>
					</div>
					<div class="mgt-2  mgb-20" v-if="degree.teacher">
						<span class="font-r t-color-headlineBlack t-body6 pdr-4">{{$t('875')}} </span><span
							class="font-r t-color-headlineBlack t-body6"> {{ degree.teacher.name?$t('3437',{first: degree.teacher.name.first, last: degree.teacher.name.last}):''}}</span>
					</div>
					<div class="d-flex align-items-baseline  ">
						<template v-if="degree.goods.paymentPrice > 0" >
							<div class="t-color-headlineBlack t-body6 pdr-4"  >KRW</div>
							<div class="t-color-headlineBlack t-headline10 pdr-8 font-b"  >{{ degree.goods.paymentPrice }}</div>
							<div class="t-body1 t-color-bodyGrayB t-line-through-red" v-if="degree.goods.paymentPrice < degree.goods.price" >{{ degree.goods.price }}</div>
						</template>
						<template v-else >
							<div class="t-color-headlineBlack t-headline10 pdr-8 font-b">{{$t('876')}}</div>
						</template>
						
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
/**
 * 강의목록 카드2 컴포넌트(degree list card item2 Component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
	props: ['degree','type'],
	
	mounted() {
		const selector = `#listCard${this.degree.id}`
		const ripples = [].map.call(document.querySelectorAll(selector), function(el) {
			return new MDCRipple(el)
		});
		
	},
	methods: {
		// 상세로 이동(move view)
		view(degreeId) {
			this.$router.push({
				name: 'DegreeView',
				params: {degreeId: degreeId},
				query: this.$route.query
			})
		}
	}
}
</script>